import * as WhatIsNewActions from './what-is-new.actions';
import { WhatIsNewState } from '@store/what-is-new/what-is-new.model';

export const whatIsNewInitialState: WhatIsNewState = {
  allAnnouncements: null
};

export function WhatIsNewReducer(state: WhatIsNewState = whatIsNewInitialState,
                                 action: WhatIsNewActions.All): WhatIsNewState {
  switch (action.type) {
    case WhatIsNewActions.GET_ALL_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        allAnnouncements: action.payload
      }

    case WhatIsNewActions.GET_ALL_ENABLED_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        allEnabledAnnouncements: action.payload
      }

    case WhatIsNewActions.GET_ALL_READ_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        allReadAnnouncements: action.payload
      }

    case WhatIsNewActions.GET_ALL_UNREAD_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        allUnreadAnnouncements: action.payload
      }

    case WhatIsNewActions.GET_ALL_ANNOUNCEMENTS_BY_CONTENT_ID_SUCCESS:
      return {
        ...state,
        announcementsByContentId: action.payload
      }

    default: {
      return state;
    }
  }
}

